import * as React from 'react'
import * as styles from './CircularButton.module.scss'

interface CircularButtonProps {
    href?: string
    icon: React.ReactNode
    onClick?: (event: React.MouseEvent) => void
}

export const CircularButton = (props: CircularButtonProps) => {
    const Tag = props.href ? 'a' : 'button'

    return (<Tag className={styles.circularButton} href={props.href} onClick={props.onClick}>
        {props.icon}
    </Tag>)
}
